/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LeftBuccalNoRetractors1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LeftBuccalNoRetractors from 'DesignSystem/Images/LeftBuccalNoRetractors/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function LeftBuccalNoRetractors1({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Instructions/Illustrations/Illustration/LeftBuccalNoRetractors"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<LeftBuccalNoRetractors
  viewPath={`${viewPath}/LeftBuccalNoRetractors`}
 width="100%"
 height="100%"
 objectFit="contain"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceM}
 marginLeft="auto"
 marginRight="auto"
/>
{children}
</React.Fragment>)
}